import apiClient from "@/apiClient";

class QuoteService {
  id = null;

  constructor(id) {
    this.id = id;
  }

  async get() {
    return apiClient.get(`/api/quote/${this.id}`);
  }

  async update(data) {
    return apiClient.put(`/api/quote/${this.id}`, data);
  }

  async manage(data) {
    return apiClient.post(`/api/quote/${this.id}/manage`, data, {
      suppressErrorAlert: true,
    });
  }

  async accept(data) {
    return apiClient.post(
      `/api/quote/${this.id}/manage`,
      {
        ...data,
        status: "accepted",
        confirm_accept: true,
      },
      {
        suppressErrorAlert: true,
      },
    );
  }

  async unlock(payload = {}) {
    return apiClient.post(`/api/quote/${this.id}/unlock`, payload);
  }

  async duplicate() {
    return apiClient.post(`/api/quote/${this.id}/duplicate`);
  }

  async pricing(versionId) {
    return apiClient.post(
      `/api/quote/${this.id}/pricing`,
      {
        version_id: versionId,
      },
      {
        suppressErrorAlert: true,
      },
    );
  }

  async latestPricing() {
    return apiClient.get(`/api/quote/${this.id}/pricing`, {
      suppressErrorAlert: true,
    });
  }

  async send(payload = {}) {
    return apiClient.post(`/api/quote/${this.id}/send`, payload);
  }

  async document() {
    try {
      return await apiClient.get(`/api/quote/${this.id}/document`, {
        responseType: "blob",
        suppressErrorAlert: true,
      });
    } catch (error) {
      if (error.response?.data instanceof Blob) {
        try {
          error.response.data = JSON.parse(await error.response.data.text());
        } catch {
          // Keep the original response when the server did not return JSON.
        }
      }
      throw error;
    }
  }

  async aiMessage(payload = {}) {
    return apiClient.post(`/api/quote/${this.id}/ai-message`, payload);
  }

  documentUrl() {
    const root = (apiClient.defaults?.baseURL ?? "").replace(/\/$/, "");
    return `${root}/api/quote/${this.id}/document`;
  }
}

export default QuoteService;
